<template>
  <section class="form-card pay-card-container">
    <div>
      <h4 class="form-card-header">{{ $t('payment.title') }}</h4>
      <p class="form-card-description">{{ $t('payment.description') }}</p>
    </div>

    <div class="pay-card-table">
      <account-info-table></account-info-table>
    </div>

<!--    <section>-->
<!--      <ic-button size="tn" color="grey" @click="previous()">{{ $t('components.back') }}</ic-button>-->
<!--      <ic-button size="tn" type="submit" variant="success" @click="next()">{{ $t('components.next') }}</ic-button>-->
<!--    </section>-->
  </section>
</template>

<script>
import AccountInfoTable from '../AccountInfoTable'

export default {
  components: {
    AccountInfoTable
  },
  methods: {
    previous() {
      this.$emit('previous');
    },
    next() {
      // TO DO: Validate and next
      this.$emit('next')
    },
  },
}
</script>

<style lang='scss' scoped>
.form-card-description {
  font-size: 1rem;
  line-height: 1.5rem;
  color: var(--text-primary-color);
}
.pay-card {
  &-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
    justify-content: space-between;
  }
  &-table {
    padding: 1rem;
    border-radius: 1rem;
    background-color: var(--tab-border-color);
    width: 100%;
  }
}
@media (max-width: 1024px) {
  .pay-card {
    &-container {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
  }
}
</style>